import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import Sidebar from '../Sidebar'


class BlogItem extends Component {
	render() {
		return (
			<div>
				<Header
					bg="#08311d"
					image={require('./image.jpg')}
					title={"Pivoting Your Social Strategy Around Coronavirus"}
				/>
				<div className="entry-content">
					
					<div className="container">
						<h2 className="blog-details">
								<div className="author-circle lauren"></div>
								<div className="line"></div>
								<div className="title">
									Written by <strong>Lauren</strong> on 01 April 2020  //  Posted in <strong>Marketing, Advertising</strong>
								</div>
						</h2>
						
						<div className="row">
							<div className="col-lg-7">
								<div className="tagline">
								<p>Everyone knows these are unprecedented and uncertain times. No one could have foreseen the damage and effect of this pandemic on the economy of the WORLD, yet alone in the South West. Needless to say, social media has most likely been the very least of your priorities as a business owner over the last few weeks. 
</p>
								</div>



<p>Given that this sort of global economic crisis hasn’t occurred before in the days of social media, it’s hard to know how to proceed. The experts on social communication don’t even know what to do! 
</p>
<p>However, when you consider that Facebook’s and Instagram’s usage has increased by 40% globally in the last week, and that everyone is staying at home to self isolate, it makes sense to put your brand out there with your offerings. 
</p>
<p> With that being said, here are some tips on navigating your social platforms through this crisis:</p>

<br></br>


<h2>1. Re-evaluate Your Goal and Social Strategy</h2>
<p>Now is not the time to be promoting social activities, group discounts, dine-in items or Happy Hour to people in self isolation. A pushy, arrogant salesperson won’t make you want to use their services - the same applies for social media today. Make sure your schedule is empathetic to people’s losses at the moment. Use this time to re-evaluate your social content calendar with the current climate in mind:
</p>
<ul class="with-icons">
<li>Does your content still seem relevant? If not, how can you pivot it to become relevant?</li>
<li>Are you being empathetic in your posts? Or are you coming across as being tone-deaf and oblivious to the world around you?</li>
<li>How can you inject some fun or lightheartedness into your strategy without seeming uninformed?</li>
</ul>
<p>
Businesses are either focusing on <b>retention</b> (keeping their existing clients), <b>sales</b> (generating contextually relevant sales, eg online yoga classes), or <b>awareness</b> (gaining new followers, spreading their brand).</p>
<p> Work out which goal you’re trying to achieve - this may help you reschedule your social posts, and pivot as needed (cue "PIVOT!"). </p>

<img src={require('./pivot.png')} alt="pivot Ross Friends" className="align-centre" align="centre" />

<br></br>


<h2>2. Don't Stop Posting Altogether</h2>
<p>I get it - most days you triple check your Facebook post before you hit ‘Publish’ - now you’re so anxious about putting out the wrong message that you’re nervous to post at all! It’s more important now more than ever to be transparent and open with your audience about your business. If you’re not posting at all, odds are people will assume you’re closed and not be able to help out, even if they were willing. </p>
<p>Being transparent was a massive social metric at the beginning of 2020, and that hasn’t changed. Take a look at V E T T A’s account:
</p>
<img src={require('./VETTA.png')} alt="VETTA Instagram Post" className="align-centre" align="centre" />


<p>Their open and honest relationship with their customers builds and trust and brand loyalty. If this is something you’re completely new to, or you’re finding it hard to be quite so open, start by creating posts that generate conversation with your audience - like ‘where can a guy get the best takeaway cappuccino from still?’ or ‘is anyone else feeling a bit cabin-feverish’?
</p>
<p>In saying that, make sure you do take stock of your feed and your audience’s reactions to your competitor’s posts before you post anything that could be taken the wrong way!</p>


<br></br>


<h2>3. Keep Current With Your Business</h2>
<p>With people eating up Facebook and Instagram feeds quicker than I can eat a Mars Bar, it’s important to stay CURRENT. Post about what’s happened to your business today, so people can have their questions answered immediately.</p> 
<p>Are you still open? Are you takeaway only? Are you offering online gym classes? Are you running a competition, or are you giving away excess stock? </p>
<p>Now is the time to be posting about what you are doing, not to get too down and out about what you can’t do.<b>This leads onto Tip 4</b>.</p>

<br></br>


<h2>4. Don't Be Afraid To Ask For Help</h2>
<p>Our community in the South West is leaning on each other like never before. Partnerships and collaborations are forming to help those less fortunate, platforms like EnableWA are starting initiatives to share essential resources amongst homes, newspapers are advertising free ad space… it’s been an experience. </p> 
<p>Don’t be afraid to reach out to other stores or businesses and ask for their support. The #ShopLocal tag has taken over by storm, and asking your customers or clients to spread your message will only help spread that community vibe. </p>
<p>There are ample Facebook groups and pages for small businesses in the South West to be a part of as well - for example, <a href="https://www.facebook.com/Bunbury-Dine-Out-106397130995945/"> Bunbury Dine Out</a> is available for local restaurants to add their takeaway menus to.</p>

<br></br>


<h2>5. Take Time Out For You</h2>
<p>Social media is an overwhelming and depressing place at the moment. Instead of keeping your face in your phone all day, try and get outside and soak up some sun - your mind will thank you for it. 
</p> 
<br></br>
<h3> It’s easy to get bogged down at the moment with thoughts of how Coronavirus is negatively affecting our area. But if we all try to help each other, and are transparent in our communications, we can get through this.</h3> 


							




							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-4">
								<Sidebar />
							</div>
						</div>
					</div>
				</div>

			</div>
		);
	}
}

export default BlogItem;


// WEBPACK FOOTER //
// ./src/Pages/Blog/Corona/index.js